import { all } from 'redux-saga/effects'
import auth from './auth/sagas'
import user from './user/sagas'
import coordinator from './coordinator/sagas'
import role from './role/sagas'
import country from './country/sagas'
import county from './county/sagas'
import place from './place/sagas'
import season from './season/sagas'
import setting from './setting/sagas'
import language from './language/sagas'
import config from './config/sagas'
import registration from './registration/sagas'
import finalist from './finalist/sagas'
import interstate from './interstate/sagas'
import statistic from './statistic/sagas'
import sportCategory from './sport/category/sagas'
import sportCompetition from './sport/competition/sagas'
import sport from './sport/sport/sagas'
import organizer from './organizer/sagas'

export default function* rootSaga() {
  yield all([
    auth(),
    user(),
    coordinator(),
    role(),
    country(),
    county(),
    place(),
    season(),
    language(),
    setting(),
    config(),
    sportCategory(),
    sportCompetition(),
    sport(),
    registration(),
    finalist(),
    interstate(),
    statistic(),
    organizer()
  ])
}
